import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class StockActivityService extends Service {
    constructor() {
        super();
        this.baseURL = 'inventory/stock';
    }

    async getCurrentStockOfProduct(productBssId) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/currentstock/" + productBssId + "/" + localStorage.getItem("merchantBranchId"), {
            headers: { 'X-Softrame-BranchId' : localStorage.getItem("merchantBranchId"),'Content-Type': 'application/json'}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }



}